import CryptoJS from "crypto-js";

export default class ToExcel {
  static utf8ToBase64(str) {
    let wordArray = CryptoJS.enc.Utf8.parse(str);
    return CryptoJS.enc.Base64.stringify(wordArray)
  }
  static format(excelFile, ctx) {
    // 执行一些逻辑来处理excelFile和ctx参数，并返回Excel文件的二进制数据
    // 如果你的Excel文件是二进制数据流，可以直接返回它
    // 如果你的Excel文件是对象或其他形式的数据，需要将其转换为二进制数据

    // 这里只是一个示例，对excelFile和ctx参数的处理可能会不同
    return excelFile + ctx
  }
  static toExcelFile(elId,fileName,worksheet="sheet") {
    // const excelContent = document.getElementById(elId).innerHTML; //表格id获取的表格html

    // console.log(document.getElementById(elId).children)
    // [].forEach()
    let tb=document.querySelector("#"+elId)

    // for (let i=0;i<tb.children.length;i++){
    //   let tr=tb.children[i];
    //   let computedStyle=window.getComputedStyle(tb.children[i],null)
    //   let styleAttributes = Object.keys(computedStyle);
    //   styleAttributes=styleAttributes.filter(ret=>isNaN(Number(ret)))
    //   styleAttributes.map(ret=>{
    //     tb.children[i].style[ret]=computedStyle[ret];
    //   })
    //   for (let j=0;j<tb.children[i].children.length;j++){
    //     let computedStyle=window.getComputedStyle(tb.children[i].children[j],null)
    //     let styleAttributes = Object.keys(computedStyle);
    //     styleAttributes=styleAttributes.filter(ret=>isNaN(Number(ret)))
    //     styleAttributes.map(ret=>{
    //       tb.children[i].children[j].style[ret]=computedStyle[ret];
    //     })
    //
    //   }
    // }

    let excelContent=tb.innerHTML;

    // console.log(tb)

    let excelFile =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
    excelFile += '<head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets>'
    excelFile +=
      '<x:ExcelWorksheet><x:Name>工作表1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>'
    excelFile += '</x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>'
    excelFile += '<body>'
    excelFile += "<table width='100%' border='1'>"
    excelFile += excelContent
    excelFile += '</table>'
    excelFile += '</body></html>'

    // console.log(excelFile)

    // 定义excel 的sheet名称
    const ctx = {worksheet: worksheet};
    const link = 'data:application/vnd.ms-excel;base64,' + ToExcel.utf8ToBase64(ToExcel.format(excelFile, ctx));
    const a = document.createElement('a');
    //定义excel 的文件名称
    a.download = fileName + '.xls'
    a.href = link
    a.click()
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Butler/common/ToExcel.js